import React from "react";
import { Chart } from "react-google-charts";

interface HoursComboChartProps {
    hoursEstimated: number;
    hoursSpent: number;
}

export const HoursChart: React.FC<HoursComboChartProps> = ({
    hoursEstimated,
    hoursSpent,
}) => {
    const chartData = [
        ["Metric", "Hours Spent", "Estimated Hours"],
        ["Work", hoursSpent, hoursEstimated],
    ];

    const options = {
        title: "Hours Spent vs Estimated Hours",
        titleTextStyle: {
            fontSize: 11, // Set the font size of the title
            fontName: "htrts_regular", // Set the font of the title
            bold: false
        },
        chartArea: { width: "60%" },
        hAxis: {
            title: "Metrics",
            textStyle: {
                fontName: "htrts_regular", // Set the font for horizontal axis
            },
        },
        vAxis: {
            title: "Hours",
            textStyle: {
                fontName: "htrts_regular", // Set the font for vertical axis
            },
        },
        seriesType: "bars",
        series: {
            2: { type: "line", color: "#FF5733" }, // Line chart for the deadline
        },
        colors: ["#4285F4", "#34A853"], // Bars colors
        legend: {
            position: "top",
            textStyle: {
                fontName: "htrts_regular", // Set the font for the legend
            },
        },
        fontName: "htrts_regular", // Set the font for the entire chart
    };

    return (
        <Chart
            chartType="ComboChart"
            width="100%"
            height={"500px"}
            data={chartData}
            options={options}
        />
    );
};